import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import { handleChange } from "../../../helpers/handleFormChanges";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";

function EditarCertificadoModal({ modalHook, valuesHook, salvaValidade }) {
  const { validadeModal, setValidadeModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Editar validade"
      is_open_modal={validadeModal}
      set_is_open_modal={setValidadeModal}
      size="md"
      buttons={
        <CommonButton
          key={`salvar-certificado`}
          color="success"
          onClick={() => {
            salvaValidade();
          }}
        >
          Salvar
        </CommonButton>
      }
    >
      <div className="col-md-12">
        <CommonInputDate
          label="Validade"
          id="validade"
          value={values.validade}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
          style={{ width: "auto" }}
        />
      </div>
    </CommonModal>
  );
}

EditarCertificadoModal.propTypes = {
  modalHook: PropTypes.shape({
    validadeModal: PropTypes.bool.isRequired,
    setValidadeModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaValidade: PropTypes.func.isRequired,
};

export default EditarCertificadoModal;
